var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userInput-wrap"},[_c('div',{staticClass:"userInput-content",class:{ userInputSjtu: _vm.owner === 'SJTU' }},[_vm._v(_vm._s(_vm.content))]),_vm._v(" "),(_vm.owner !== 'SJTU')?_c('div',{staticClass:"userInput-portrait"},[_c('img',{attrs:{"src":_vm.portrait,"alt":"portrait"}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-d0311fbe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/app/GenH5/UserInput.vue
// module id = null
// module chunks = 